<template>
  <div
    ref="boxSubject2"
    class="box-subject"
    :style="{ maxHeight: mydata.maxHeight }"
  >
    <p>
      <!-- 文字 -->
      <span
        :style="{
          display: 'inline-block',
          width: props.textWidth,
          'flex-shrink': 0,
          'text-align': 'right',
        }"
        >{{ props.filterButton.title }}：</span
      >
      <!-- 选项 -->
      <el-radio-group v-model="mydata.checkUnitValue" @change="checkListChange">
        <!-- 写死的全部 -->
        <el-radio-button
          class="index-is-0-btn"
          label="全部"
          value=""
        ></el-radio-button>

        <div class="box">
          <div class="my-radio-box">
            <!-- 动态的循环 -->
            <el-radio-button
              v-for="(item, index) in props.filterButton.filter"
              :key="index"
              :label="item.label"
              :value="item.name"
            >
            </el-radio-button>
          </div>

          <!-- 内容超过两行了才会显示箭头 -->
          <template v-if="mydata.haveMore">
            <el-icon
              class="my-icon-arrow"
              @click="clickShowMore"
              v-if="!mydata.isOpened"
              ><ArrowDown
            /></el-icon>
            <el-icon
              class="my-icon-arrow"
              @click="clickShowMore"
              v-if="mydata.isOpened"
              ><ArrowUp
            /></el-icon>
          </template>
        </div>
      </el-radio-group>
    </p>
  </div>
</template>

<script setup>
import { nextTick, reactive, ref, watch } from "vue";
import { ArrowDown, ArrowUp } from "@element-plus/icons-vue";

const boxSubject2 = ref();

const mydata = reactive({
  checkAll: false,
  isIndeterminate: true,
  checkUnitValue: "",
  haveMore: false,
  maxHeight: "65px",
  isOpened: false,
  scrollHeight: 0,
});

const props = defineProps({
  // 全的
  filterButton: {
    type: Object,
    default: () => {
      return {};
    },
  },
  textWidth: {
    type: String,
    default: "45px",
  },
});

watch(
  () => {
    return props.filterButton;
  },
  (n, o) => {
    fn();
  },
  {
    immediate: true,
    deep: true,
  }
);

const emits = defineEmits(["change"]);

// 展示更多
function clickShowMore() {
  mydata.maxHeight =
    mydata.maxHeight === "65px" ? mydata.scrollHeight + "px" : "65px";
  mydata.isOpened = !mydata.isOpened;
}

/** 多选框改变事件 */
function checkListChange() {
  // console.log("最终结果", mydata.checkUnitValue);
  // 发送自定义事件
  emits("change", mydata.checkUnitValue);
}

function fn() {
  nextTick(() => {
    // mydata.scrollHeight = boxSubject2.value.scrollHeight;
    // mydata.haveMore = mydata.scrollHeight > 65 ? true : false;
  });
}
</script>

<style scoped lang="scss">
.box-subject {
  > p {
    // width:32px;
    height: 32px;
    display: flex;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 32px;

    > span {
      // width: 44px;
      // border:1px solid red;
      font-size: 14px;
      margin-left: 16px;
      margin-top: -0.5px;
    }

    :deep(.el-button) {
      height: 32px;
      border-radius: 4px;
      border: 1px solid #009de0;
      color: #ffffff;
      font-size: 14px;
      font-weight: 400;
      line-height: 32px;
      margin-right: 15px;
      // border:1px solid rgb(60, 255, 0);
    }

    :deep(.el-radio-button) {
      // padding: 4px 14px;
      height: 32px;
      // height: 32px;
      // border-radius: 4px;

      // border:1px solid #D9D9D9CC;
      // border:1px solid red;
      border: 1px solid #009de0;
      border: none;
      min-width: 64px;
      // height: 28px;
      padding: 0;
      // flex-wrap: nowrap !important;
      // margin-right: 16px;
    }

    :deep(.el-radio-button__inner) {
      // color:red;
      font-size: 14px;
      font-weight: 400;
      height: 32px;

      border: none;

      border-color: rgba(217, 217, 217, 0.8);
      border: none;
      background: transparent;
      // border: 1px solid #009DE0;
      width: 100%;
      height: 100%;
      text-align: center;
      line-height: 32px;
      padding: 0 10px;
      // border-left-color: #009DE0 !important;
      color: #333;
      border-radius: 4px;
      border: none !important;
      box-shadow: none;
    }
    // :deep(.el-radio-button.is-active){
    //     border:1px solid black;
    // }
    :deep(.el-radio-button.is-active.index-is-0-btn .el-radio-button__inner) {
      background: #009de0;
      color: #fff;
    }
    :deep(.el-radio-button.is-active .el-radio-button__inner) {
      border: 1px solid #009de0 !important;
      color: #009de0;
    }
  }
}
:deep(.el-radio-group) {
  flex-wrap: nowrap;
  align-items: flex-start;
  width: 100%;
  height: 32px;
  margin-right: 16px;
  .box {
    width: 100%;
    .my-radio-box {
      width: 100%;
      // border: 1px solid red;
      display: flex;
      flex-wrap: nowrap;
      // border: 1px solid red;
      margin-bottom: 10px;
      .el-radio-button {
        // width: 30%;
        .el-radio-button__inner {
          // border: 1px solid pink;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
:deep(.my-icon-arrow) {
  font-size: 20px;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0px, -10px);
  cursor: pointer;
}

.my-radio-box {
  width: 250px;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  // border: 1px solid blue;

  :deep(.el-radio-button) {
    flex-wrap: nowrap !important;
  }
}

/* 针对webkit内核浏览器 */
.my-radio-box::-webkit-scrollbar {
  display: none !important; /* 隐藏滚动条 */
}
.my-radio-box::-webkit-scrollbar-thumb {
  display: none !important; /* 隐藏滚动条 */
}

.my-radio-box {
  /* 针对Firefox */
  scrollbar-width: none; /* Firefox中隐藏滚动条 */

  /* 针对IE和Edge */
  -ms-overflow-style: none; /* IE和Edge中隐藏滚动条 */
}
</style>
